import type { Store } from './port';
import { createDesktopStore } from './desktop';
import { createSqliteStore } from './sqlite';
import { createWebStore } from './web';
import { gereiht } from './reihe';
import { istDesktop, istGeraet } from '../platform/gleis';

/**
 * Die eine Ablage der App — eine je Gleis ([[drittes-gleis]]):
 *
 * - **Gerät:** SQLite über das Capacitor-Plugin.
 * - **Desktop:** echtes SQLite im Hauptprozess, dieselbe Kette, dieselben Anweisungen.
 * - **Browser:** IndexedDB — Entwicklungswerkzeug, kein Prüfungsbetrieb (s. `web.ts`).
 *
 * Die Wahl fällt einmal und ist von aussen nicht zu sehen.
 */
let store: Store | null = null;

export function getStore(): Store {
  if (!store) {
    // Gereiht: zwei Aufrufer, die nichts voneinander wissen (Autospeichern und Senden), dürfen
    // sich nicht in die Quere kommen — s. `reihe.ts`.
    if (istGeraet()) store = gereiht(createSqliteStore());
    else if (istDesktop()) store = gereiht(createDesktopStore());
    else store = gereiht(createWebStore());
  }
  return store;
}

/**
 * Läuft der Code gerade unter Vitest? `import.meta.env.DEV` taugt hier nicht als Schranke:
 * das ist unter Vitest genauso `true` wie im echten Entwicklungsbetrieb auf dem Gerät
 * (`cap run ios --live-reload`) — genau dort soll die Schranke aber greifen. Vitest selbst
 * setzt `process.env.VITEST`; im echten Browser/WKWebView gibt es kein `process`. Der Umweg
 * über `globalThis` statt der bloßen Kennung `process` vermeidet eine zusätzliche Abhängigkeit
 * auf `@types/node` nur für diese eine Prüfung — im Browser ist `process` dort schlicht
 * `undefined`, kein Fehler.
 */
const unterTest =
  (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env
    ?.VITEST === 'true';

/**
 * Nur für Tests: eine bereitgestellte Ablage untermischen.
 *
 * Außerhalb von Vitest wirft dieser Aufruf. Ohne die Schranke tauschte ein versehentlicher
 * Aufruf aus Anwendungscode die Geräte-Ablage lautlos gegen eine andere aus — bei einer App,
 * die Prüfungsergebnisse hält, wäre das Datenverlust durch eine Testluke.
 */
export function resetStoreForTests(ersatz: Store): void {
  if (!unterTest) {
    throw new Error('resetStoreForTests() ist nur unter Vitest erlaubt.');
  }
  store = ersatz;
}
